export const SUPER_ADMIN_USERS_QUERY_KEY = ["super-admin-users"] as const;

export interface SuperAdminUserCompany {
  id: number;
  businessName: string;
  UsersCompany?: {
    isConfirmedByUser: boolean;
    isDefault: boolean;
    isOwner: boolean;
  };
}

export interface SuperAdminUserRole {
  id: number;
  type: string;
}

export interface SuperAdminUserWorkforce {
  uid: string;
  companyId: number;
  workforceRole: string | null;
  status: string;
}

export interface SuperAdminUser {
  uid: string;
  avatar: string | null;
  email: string;
  firstName: string;
  lastName: string;
  alias: string | null;
  useAliasAsDisplayName: boolean;
  phone: string | null;
  isEmailConfirmed: boolean;
  isPhoneConfirmed: boolean;
  createdAt: string;
  updatedAt: string;
  companies: SuperAdminUserCompany[];
  roles: SuperAdminUserRole[];
  workforces: SuperAdminUserWorkforce[];
  recordType: "user" | "workforce";
}

export interface SuperAdminUsersMetrics {
  totalUsers: number;
  confirmedUsers: number;
  companyOwners: number;
  linkedWorkforces: number;
  workforcesWithoutAccount: number;
}

export interface SuperAdminUsersResult {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  items: SuperAdminUser[];
  metrics: SuperAdminUsersMetrics;
}

export interface SuperAdminUsersResponse {
  status: number;
  message: string;
  data: SuperAdminUsersResult;
}
